module.exports = __webpack_public_path__ + "img/yuanmingyuan big (5).c2e77ea5.jpg";